import { render, staticRenderFns } from "./similarColumn.vue?vue&type=template&id=65f92f5c&scoped=true&"
import script from "./similarColumn.vue?vue&type=script&lang=js&"
export * from "./similarColumn.vue?vue&type=script&lang=js&"
import style0 from "./similarColumn.vue?vue&type=style&index=0&id=65f92f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f92f5c",
  null
  
)

export default component.exports